export default "/images/preview_bf_halfpage.webp?d8f90369f792cefaaac729f893b57aa9";